module.exports = __webpack_public_path__ + "static/media/Admin.335ada59.png";